import type { PropertyValidationResult } from '../../../types/properties';

export default function validator(properties: Record<string, any>): PropertyValidationResult {
  const errors: Array<{ key: string; message: string }> = [];
  const operation = properties.operation || 'uppercase';

  // Most operations need field input
  const needsField = ['uppercase', 'lowercase', 'trim', 'replace', 'split', 'substring', 'length'];
  if (needsField.includes(operation)) {
    if (!properties.field || properties.field.trim() === '') {
      errors.push({
        key: 'field',
        message: 'Input string is required',
      });
    }
  }

  // Concat needs at least 2 strings
  if (operation === 'concat') {
    const strings = properties.strings?.values;
    if (!strings || strings.length < 2) {
      errors.push({
        key: 'strings',
        message: 'At least 2 strings are required for concatenation',
      });
    }
  }

  // Replace needs search value
  if (operation === 'replace') {
    if (!properties.searchValue || properties.searchValue === '') {
      errors.push({
        key: 'searchValue',
        message: 'Search value is required',
      });
    }
  }

  // Substring start must be >= 0
  if (operation === 'substring') {
    if (properties.start !== undefined && properties.start < 0) {
      errors.push({
        key: 'start',
        message: 'Start position must be 0 or greater',
      });
    }
  }

  return {
    valid: errors.length === 0,
    errors,
  };
}
